import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  Grid,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import useFirestore from "../../../../config/fireBaseHook"; // Import useFirestore
import { DivisionsByIdDropdown } from "../../CourseCatalog/DropDowns";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Add = ({ onRecordAdded }) => {
  const { addData } = useFirestore("PathwaysPrograms"); // Specify collection name
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [formData, setFormData] = useState({
    PathwayID: "",
    PathwayName: "",
    PathwayNameShort: "",
    PathwayAbbrev: "",
    Career_Field_Cd: "",
    DivisionID: "",
    SCCDirector: "",
    SCCProgramMgr: "",
    SCCLiason: "",
    HEIProgramName: "",
    Notes: "",
    Start_Date: "",
    End_Date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addData(formData); // Use Firestore hook's addData
      setLoading(false);
      setSnackbarMessage("Record has been added successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setFormData({
        PathwayID: "",
        PathwayName: "",
        PathwayNameShort: "",
        PathwayAbbrev: "",
        Career_Field_Cd: "",
        DivisionID: "",
        SCCDirector: "",
        SCCProgramMgr: "",
        SCCLiason: "",
        HEIProgramName: "",
        Notes: "",
        Start_Date: "",
        End_Date: "",
      });
      setOpen(false);
      if (onRecordAdded) onRecordAdded(); // Call the callback function
    } catch (error) {
      console.error("Error adding record:", error);
      setLoading(false);
      setSnackbarMessage(`Error adding record: ${error.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="success"
        onClick={() => setOpen(true)}
        sx={{ marginBottom: "10px", color: "white" }}
      >
        Add Pathway Program
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <ModalDialogTitle onClose={() => setOpen(false)}>
          Add Pathway Program
        </ModalDialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Pathway ID"
                name="PathwayID"
                value={formData.PathwayID}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Pathway Name"
                name="PathwayName"
                value={formData.PathwayName}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Pathway Name Short"
                name="PathwayNameShort"
                value={formData.PathwayNameShort}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Pathway Abbreviation"
                name="PathwayAbbrev"
                value={formData.PathwayAbbrev}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Career Field Code"
                name="Career_Field_Cd"
                value={formData.Career_Field_Cd}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DivisionsByIdDropdown
                value={formData.DivisionID}
                onChange={handleChange}
                name="DivisionID"
                label="Division"
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="SCC Director"
                name="SCCDirector"
                value={formData.SCCDirector}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="SCC Program Manager"
                name="SCCProgramMgr"
                value={formData.SCCProgramMgr}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="SCC Liason"
                name="SCCLiason"
                value={formData.SCCLiason}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="HEI Program Name"
                name="HEIProgramName"
                value={formData.HEIProgramName}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Notes"
                name="Notes"
                value={formData.Notes}
                onChange={handleChange}
                fullWidth
                margin="normal"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Start Date"
                name="Start_Date"
                value={formData.Start_Date}
                onChange={handleChange}
                fullWidth
                margin="normal"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="End Date"
                name="End_Date"
                value={formData.End_Date}
                onChange={handleChange}
                fullWidth
                margin="normal"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} />
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Add;
